// Facebook Analytics Service
class FacebookService {
  constructor() {
    this.baseURL = 'https://cgb-backend.carl-g-bisaillon.workers.dev/api';
  }

  // Get Facebook page analytics
  async getPageAnalytics(timeRange = '7d') {
    try {
      const response = await fetch(`${this.baseURL}/analytics/facebook`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Facebook analytics:', error);
      throw error; // Don't return mock data
    }
  }

  // Get Facebook page posts/feed
  async getPagePosts(limit = 10) {
    try {
      const response = await fetch(`${this.baseURL}/social/facebook/posts`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Facebook posts:', error);
      throw error; // Don't return mock data
    }
  }

  // Get Facebook audience insights
  async getAudienceInsights() {
    try {
      const response = await fetch(`${this.baseURL}/analytics/facebook/audience`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Facebook audience insights:', error);
      throw error; // Don't return mock data
    }
  }

  // Get comprehensive Facebook data for tiles
  async getComprehensiveData() {
    try {
      const [analytics, posts, audience] = await Promise.all([
        this.getPageAnalytics(),
        this.getPagePosts(),
        this.getAudienceInsights()
      ]);

      return {
        analytics,
        posts,
        audience,
        timestamp: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error fetching comprehensive Facebook data:', error);
      throw error; // Don't return mock data
    }
  }

}

export const facebookService = new FacebookService();
export default facebookService;

